import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatProgressBar} from "@angular/material";
import {ExcelModule, GridModule, PDFModule} from '@progress/kendo-angular-grid';
import { DialogModule } from '@progress/kendo-angular-dialog';

import { FrameworkBodyComponent } from './framework-body/framework-body.component';
import { ContentComponent } from './content/content.component';
import { TitleBarComponent } from './title-bar/title-bar.component';
import { FrameworkConfigService } from './services/framework-config.service';
import { TopBarComponent } from './top-bar/top-bar.component';
import { StatusBarComponent } from './status-bar/status-bar.component';
import { ScreenService } from './services/screen.service';
import { ScreenLarge } from './directives/screen-large.directive';
import { ScreenBelowLarge } from './directives/screen-below-large.directive';
import { SignInComponent } from './users/sign-in.component';
import { MenuComponent } from './menu/menu.component';
import { SubmenuComponent } from './menu/submenu.component';
import { MenuItemComponent } from './menu/menu-item.component';
import { SubmenuItemComponent } from './menu/submenu-item.component';
import { MenuService } from './services/menu.service';
import { BreadcrumService } from './services/breadcrum.service';
import { FormService } from './services/form.service';
import { BreadcrumComponent } from './breadcrum/breadcrum.component';
import { PageHeaderBarComponent } from './pages/page-header-bar.component';
import { PageSubheaderBarComponent } from './pages/page-subheader-bar.component';
import { PageSearchableListComponent } from './pages/page-searchable-list.component';
import { PageListComponent } from './pages/page-list.component';
import { DynamicFormComponent } from './dynamic-forms/dynamic-form.component';
import { DynamicFieldComponent } from './dynamic-forms/dynamic-field.component';
import { DynamicGridComponent } from './dynamic-grids/dynamic-grid.component';
import { BarButtonComponent } from './buttons/bar-button.component';
import { RowDoubleClickDirective }   from './directives/row-double-click.directive';
import {AutofocusDirective} from "./directives/autofocus.directive";

import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import {LoaderService} from "./loader/loader.service";
import {LoaderComponent} from "./loader/loader.component";
import {InputsModule} from "@progress/kendo-angular-inputs";
import {ClipboardService} from "./services/clipboard.service";
import {AuthGuard} from "./services/auth-guard.service";
import {UserApi} from "./users/user-api";
import {UserService} from "./services/user.service";
import {HttpDateInterceptorModule} from "./http-date-interceptor";
import {HttpRequestInterceptorModule} from "./http-request-interceptor";
import {DatePickerDefaultsDirective} from "./directives/date-picker-defaults.directive";
import {TimePickerDefaultsDirective} from "./directives/time-picker-defaults.directive";

registerLocaleData(localeNl);

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        GridModule,
        ExcelModule,
        PDFModule,
        DialogModule,
        InputsModule,
        HttpRequestInterceptorModule,
        HttpDateInterceptorModule
    ],
    declarations: [
        FrameworkBodyComponent,
        ContentComponent,
        TitleBarComponent,
        TopBarComponent,
        StatusBarComponent,
        ScreenLarge,
        ScreenBelowLarge,
        SignInComponent,
        MenuComponent,
        SubmenuComponent,
        MenuItemComponent,
        SubmenuItemComponent,
        BreadcrumComponent,
        PageHeaderBarComponent,
        PageSubheaderBarComponent,
        PageSearchableListComponent,
        PageListComponent,
        DynamicFormComponent,
        DynamicFieldComponent,
        DynamicGridComponent,
        BarButtonComponent,
        RowDoubleClickDirective,
        AutofocusDirective,
        LoaderComponent,
        MatProgressBar,
        DatePickerDefaultsDirective,
        TimePickerDefaultsDirective
    ],
    providers: [
        FrameworkConfigService,
        ScreenService,
        MenuService,
        BreadcrumService,
        FormService,
        LoaderService,
        ClipboardService,
        UserService,
        {provide: UserApi, useExisting: UserService},
        AuthGuard,
    ],
    exports: [
        FrameworkBodyComponent,
        MenuComponent,
        SubmenuComponent,
        BreadcrumComponent,
        PageSearchableListComponent,
        PageListComponent,
        DynamicFormComponent,
        DynamicGridComponent,
        BarButtonComponent,
        PageHeaderBarComponent,
        PageSubheaderBarComponent,
        RowDoubleClickDirective,
        AutofocusDirective,
        LoaderComponent,
        DatePickerDefaultsDirective,
        TimePickerDefaultsDirective
    ]
})
export class FwModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/fw.module.ts